const config = {
  API_BASE_URL: '/api', // same for development (proxied) and production (nginx)
};

export default config;
